import { ThemeService } from '../../../../theme/theme.service';
import { app_themes } from '../../../../theme/themes.const';
import { ThemeDirective } from '../../../../theme/theme.directive';

const darkColor = '#212121';

const axisCommon = function() {
  return {
    axisLine: {
      lineStyle: {
        color: darkColor
      }
    },
    axisTick: {
      lineStyle: {
        color: darkColor
      }
    },
    axisLabel: {
      textStyle: {
        color: darkColor
      }
    },
    splitLine: {
      lineStyle: {
        type: 'dashed',
        color: '#aaa'
      }
    },
    splitArea: {
      areaStyle: {
        color: darkColor
      }
    }
  };
};

export function getChartTheme(theme: string) {
  let colorPalette: Array<string> = [
    '#FF6666',
    '#51F5B1',
    '#EF3A3A',
    '#E5BE00',
    '#33A06E',
    '#A3A3A3'
  ];

  const appTheme = app_themes[theme];
  if (appTheme) {
    colorPalette = [
      appTheme['--primary'],
      appTheme['--secondary'],
      appTheme['--red'],
      appTheme['--yellow'],
      appTheme['--blue'],
      appTheme['--grey']
    ];
  }

  return {
    color: colorPalette,

    title: {
      textStyle: {
        fontWeight: 'lighter',
        color: darkColor
      }
    },

    timeAxis: axisCommon(),
    logAxis: axisCommon(),
    valueAxis: axisCommon(),
    categoryAxis: axisCommon(),

    visualMap: {
      color: [colorPalette[0], colorPalette[4]]
    },

    toolbox: {
      iconStyle: {
        normal: {
          borderColor: colorPalette[1]
        }
      }
    },

    tooltip: {
      backgroundColor: 'rgba(50,50,50,0.5)',
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: '#27727B',
          type: 'dashed'
        },
        crossStyle: {
          //  color: '#27727B',
        },
        shadowStyle: {
          color: 'rgba(200,200,200,0.3)'
        }
      }
    },

    dataZoom: {
      dataBackgroundColor: '#F5F5F5',
      fillerColor: 'rgba(245, 245, 245, 0.4)',
      handleColor: colorPalette[1]
    },

    timeline: {
      lineStyle: {
        color: '#27727B'
      },
      controlStyle: {
        normal: {
          color: '#27727B',
          borderColor: '#27727B'
        }
      },
      symbol: 'emptyCircle',
      symbolSize: 3
    },

    line: {
      itemStyle: {
        normal: {
          borderWidth: 1,
          borderColor: '#fff',
          lineStyle: {
            width: 1
          }
        },
        emphasis: {
          borderWidth: 1
        }
      },
      symbol: 'circle',
      symbolSize: 3
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/themes/customTheme.ts